import { PlusOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const Upload = ({ children, ...props }) => {
  const fileInputRef = useRef(null);
  return (
    <>
      <button
        {...props}
        className={cn(
          'flex w-[140px] h-[114px] p-16 flex-col justify-center items-center gap-8 rounded-[4px] border-[1px] border-dashed border-outline-default-secondary bg-white',
          props.className
        )}
        type="button"
        onClick={() => {
          fileInputRef.current.click();
        }}
      >
        {children || (
          <>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </>
        )}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        accept="image/*"
        {...props}
      />
    </>
  );
};

export default Upload;
